import './index.styl';
import template from './index.jst';
import _ from 'lodash';
import { View } from 'backbone.marionette';
import Radio from 'backbone.radio';

import { User, FantasyTeam } from '../../../../models';
import { jumpToAnchor } from '../../../../utils';

const
	silent = { silent: true },
	fieldChannel = Radio.channel('field'),
	coachChannel = Radio.channel('coach');

export class InfoBar extends View {
	get template() {
		return template;
	}

	ui() {
		return {
			close: '.js-assistant-coach-bar-close',
			more: '.js-more',
			share: '.js-sharing',
			change_stats: '.js-additional-stats'
		}
	}

	events() {
		return {
			'click @ui.close': 'onCloseBanner',
			'click @ui.more': 'onMore',
			'click @ui.share': 'shareTeam',
			'change @ui.change_stats': 'changeStats',

		}
	}

	initialize() {
		this.share = this.getOption('share');
		this.team = this.getOption('team');
		this.team_info = this.getOption('team_info');

		const
			path_url = process.env.AVATARS_PATH + User.get('id'),
			version = User.get('avatar_version') || Date.now(),
			is_show_banner = User.with_trial && !User.get('coach_trial_popup');

		let trial_coach_text = 'Your complimentary FREE Coach' +
			' trial is active <b class="time-info">Ends soon!</b>';

		if (User.trial_days_to_end <= 7) {
			trial_coach_text = 'Your complimentary FREE Coach' +
				' trial is almost over! <b class="time-info">Ends soon!</b>';
		}

		if (User.is_coach_trial_end && !User.get('coach_trial_popup')) {
			trial_coach_text = 'Your complimentary FREE Coach' +
				' trial is over! Want to activate Coach?';

			User.set({ coach_trial_popup: 1 }, silent);

			User.updateUserData();
		}

		const stats = [
			{ key: 'Price', val: 'cost' },
			{ key: 'Average (AVG)', val: 'stats.avg_points' },
			{ key: 'Total Points (TOT)', val: 'stats.total_points' },
			// { key: 'Points Last Round', val: 'stats.points_last_round' },
			{ key: 'Selected by % (TS%)', val: 'stats.owned_by' },
			{ key: '$ / Points ($/PTS)', val: 'stats.cost_divided_by_points' },
			{ key: 'Form (L3 AVG)', val: 'stats.last_3_avg' },
			{ key: 'Breakeven', val: 'stats.break_even' },
			{ key: 'Projected Score', val: 'stats.proj_score' },
		];

		this.model = new FantasyTeam({
			avatar_url: `${path_url}.png?v=${version}`,
			is_show_banner,
			trial_coach_text,
			selected_stats: _.first(stats).val,
			stats
		});

		this.listenTo(this.model, 'change', this.render);
	}

	init({ team }) {
		this.model.set(team, silent);

		let { team_size } = this.model;

		this.model
			.set({ team_size }, silent)
			.trigger('change');

		this.trigger('with:coach:banner', this.model.get('is_show_banner'));

		return this;
	}

	onMore(event) {
		const { href } = event.currentTarget;

		jumpToAnchor(href);

		this.close();
	}

	onCloseBanner() {
		this.model.set({
			is_show_banner: false
		});

		this.trigger('with:coach:banner', false);
	}

	shareTeam(element) {
		let data = {
			sc: $(element.currentTarget).data('type'),
			team_id: this.team.get('id')
		};

		this.share.set({
			team: this.team.toJSON(),
			team_info: this.team_info.toJSON()
		}).share(data);
	}

	changeStats() {
		const
			selected_stats = this.ui.change_stats.val(),
			is_coach_stat = ['stats.break_even', 'stats.proj_score'].includes(selected_stats);

		if(is_coach_stat && !User.has_assistant_coach){
			this.ui.change_stats.val(this.model.get('selected_stats'));
			coachChannel.trigger('show:popup');

			return this;
		}

		this.model.set({ selected_stats	}, silent);

		fieldChannel.trigger('change:stat:field', selected_stats);
	}
}

export default InfoBar;